<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50" @click.self="closeModal">
    <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8">
      <div class="w-[100vw] md:w-4/5 xl:w-[40%] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden max-w-[450px]">
          <div class="flex flex-col justify-center items-start gap-[22px] p-[20px] pt-[12px]">
            <div class="w-full flex flex-col items-center">
              <EditIcon class="w-[50px] h-[50px] p-[4px] text-primary" />
              <span class="PC_Body1-SB !text-[#1F1D1F] h-[24px]">
                แบบประเมิน
              </span>
            </div>
            <SelectBox2 label="แบบประเมินที่ต้องการทำ" :inputId="'assessmentID'" :keyValue="'id'" :keyName="'name'"
              :options="assessmentOption" :value="form.id" :placeholder="'เลือกแบบประเมิน'" @update:modelValue="
                (res) => {
                  form.id = res;

                }
              " />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent :label="'ยกเลิก'" :bClass="'btn_shadow--cancel'" @clicked="closeModal" />
              <ButtonComponent :label="'เลือก'" :bClass="'btn_shadow--save'" :disabled="!form.id"
                @clicked="takeAssessment" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const assessmentOption = [
  { id: 2, name: "แบบบันทึกเวชระเบียนของทีมปฏิบัติการฉุกเฉิน" },
  {
    id: 3,
    name: "แบบบันทึกเวชระเบียนของทีมปฏิบัติการฉุกเฉิน (อายุน้อยกว่า 5 ปี)",
  },
];

const route = useRoute();
const router = useRouter();
const input = {
  id: "",
  data: "",
};
const userProfile = ref({});
const form = ref({ ...input });
const dataFormPopulation = ref({});

const modalIsOpened = ref(false);

const openModal = (data) => {
  console.log("data :: ", data);
  userProfile.value = data
  dataFormPopulation.value = data
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
};

const closeModal = () => {
  form.value = {
    id: "",
    data: "",
  }
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const routeMap = (value = 1) => ({
  "victim-detail-in-shelter": () => `/shelter/${route.meta.decodedParams?.shelterId}/victims/${route.meta.decodedParams?.victimId}/${userProfile.value.id}/null/form${value}`,
  "victims-detail": () => `/population/victims/${route.meta.decodedParams?.victimId}/${userProfile.value.id}/null/form${value}`,
  "post-disaster-period-detail": () => `/population/post-disaster-period/${route.meta.decodedParams?.victimId}/${userProfile.value.id}/null/form${value}`,
  "population-detail": () => `/population/total-population/${route.meta.decodedParams?.populationId}/${userProfile.value.id}/null/form${value}`,
});

const goTo = (value = 1) => {
  console.log("route.name :: ", route.name);
  console.log("route.params :: ", route.params);

  const path = routeMap(value)[route.name];
  if (path) {
    router.push(path());
  }
};

const takeAssessment = () => {
  goTo(form.value.id);
  closeModal();
};


defineExpose({ openModal });
</script>

<style lang="scss" scoped></style>